// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  --color-canvas: #f4f6f3;
  --color-surface: #ffffff;
  --color-surface-muted: #edf3ef;
  --color-surface-muted-rgb: 237, 243, 239;
  --color-text: #24342c;
  --color-text-rgb: 36, 52, 44;
  --color-text-muted: #66746c;
  --color-border: #dbe3dd;
  --color-border-rgb: 219, 227, 221;
  --color-brand: #276a54;
  --color-brand-hover: #1d5844;
  --color-brand-soft: #e5f0e9;
  --color-brand-rgb: 39, 106, 84;
  --color-danger: #b94f46;
  --color-danger-hover: #a33f38;
  --color-danger-soft: #faece9;
  --color-danger-rgb: 185, 79, 70;
  --color-warning: #95620d;
  --color-warning-soft: #fff4d8;
  --color-warning-rgb: 149, 98, 13;
  --color-success: #2f704d;
  --color-success-soft: #eaf4ec;
  --color-success-rgb: 47, 112, 77;
  --color-info: #286887;
  --color-info-soft: #eaf3f8;
  --color-info-rgb: 40, 104, 135;
  --color-on-brand: #ffffff;
  --shadow-panel: 0 1px 3px rgba(36, 52, 44, 0.05), 0 8px 24px rgba(36, 52, 44, 0.04);
  --shadow-overlay: 0 18px 48px rgba(36, 52, 44, 0.2);
  --radius-control: 10px;
  --radius-panel: 14px;
  --font-ui: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans', sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-ui);
  color: var(--color-text);
  background: var(--color-canvas);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button,
input,
select,
textarea {
  font: inherit;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(var(--color-brand-rgb), 0.4);
  outline-offset: 2px;
}

html {
  scrollbar-color: var(--color-border) var(--color-canvas);
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: var(--color-canvas);
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
  border: 2px solid var(--color-canvas);
  border-radius: 999px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-muted);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;EACxC,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,mFAAmF;EACnF,mDAAmD;EACnD,sBAAsB;EACtB,oBAAoB;EACpB,yFAAyF;AAC3F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;EAC/B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;aACW;AACb;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\n  color-scheme: light;\n  --color-canvas: #f4f6f3;\n  --color-surface: #ffffff;\n  --color-surface-muted: #edf3ef;\n  --color-surface-muted-rgb: 237, 243, 239;\n  --color-text: #24342c;\n  --color-text-rgb: 36, 52, 44;\n  --color-text-muted: #66746c;\n  --color-border: #dbe3dd;\n  --color-border-rgb: 219, 227, 221;\n  --color-brand: #276a54;\n  --color-brand-hover: #1d5844;\n  --color-brand-soft: #e5f0e9;\n  --color-brand-rgb: 39, 106, 84;\n  --color-danger: #b94f46;\n  --color-danger-hover: #a33f38;\n  --color-danger-soft: #faece9;\n  --color-danger-rgb: 185, 79, 70;\n  --color-warning: #95620d;\n  --color-warning-soft: #fff4d8;\n  --color-warning-rgb: 149, 98, 13;\n  --color-success: #2f704d;\n  --color-success-soft: #eaf4ec;\n  --color-success-rgb: 47, 112, 77;\n  --color-info: #286887;\n  --color-info-soft: #eaf3f8;\n  --color-info-rgb: 40, 104, 135;\n  --color-on-brand: #ffffff;\n  --shadow-panel: 0 1px 3px rgba(36, 52, 44, 0.05), 0 8px 24px rgba(36, 52, 44, 0.04);\n  --shadow-overlay: 0 18px 48px rgba(36, 52, 44, 0.2);\n  --radius-control: 10px;\n  --radius-panel: 14px;\n  --font-ui: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans', sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-ui);\n  color: var(--color-text);\n  background: var(--color-canvas);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 3px solid rgba(var(--color-brand-rgb), 0.4);\n  outline-offset: 2px;\n}\n\nhtml {\n  scrollbar-color: var(--color-border) var(--color-canvas);\n  scrollbar-width: thin;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-canvas);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-border);\n  border: 2px solid var(--color-canvas);\n  border-radius: 999px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-text-muted);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
